import { render, staticRenderFns } from "./EpayPurposeOfRemittanceOptions.vue?vue&type=template&id=4284341c&scoped=true"
import script from "./EpayPurposeOfRemittanceOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./EpayPurposeOfRemittanceOptions.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4284341c",
  null
  
)

/* custom blocks */
import block0 from "capitalist-shared/src/finance/locales/ru/payout.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Fbigmate%2Fcapitalist-legacy-assets%2Fpackages%2Fwebapp%2Fsrc%2Fcomponents%2Fforms%2Fpayout%2Fforms%2Fepay%2FEpayPurposeOfRemittanceOptions.vue&locale=ru&external"
if (typeof block0 === 'function') block0(component)
import block1 from "capitalist-shared/src/finance/locales/en/payout.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Fbigmate%2Fcapitalist-legacy-assets%2Fpackages%2Fwebapp%2Fsrc%2Fcomponents%2Fforms%2Fpayout%2Fforms%2Fepay%2FEpayPurposeOfRemittanceOptions.vue&locale=en&external"
if (typeof block1 === 'function') block1(component)

export default component.exports